import { InjectionToken } from '@angular/core';

/**
 * Cycle-safe handle for the native touchpoint-container modal launcher.
 *
 * The concrete `NativeTouchpointContainerService` imports
 * `FtTouchpointContainerComponent` (to `createComponent` it), which in turn
 * imports `LegacyShimsModule`. `FtTouchpointTriggerDirective` is DECLARED in
 * `LegacyShimsModule` — the first re-export of the early-evaluated account-shared
 * barrel — so if that directive imported the service directly, the barrel would
 * re-enter itself mid-evaluation (`@Component` reading `LegacyShimsModule` before
 * its class declaration runs) and blank the whole SPA at runtime (the AOT build
 * still succeeds). See [[project_account_barrel_eval_order_fragility]].
 *
 * The directive therefore injects THIS leaf token (imports nothing heavier than
 * `@angular/core`). The token → service binding is provided in
 * `AdvocacyGroupModule` (the directive's sole host, evaluated AFTER the barrel),
 * resolving to the `providedIn:'root'` service singleton via `useExisting`.
 */
export interface NativeTouchpointContainerLauncher {
  show(campaignUuid: string, propertyUuid: string, touchpointName: string, dataType?: string): void;
  hide(): void;
}

export const NATIVE_TOUCHPOINT_CONTAINER = new InjectionToken<NativeTouchpointContainerLauncher>(
  'NativeTouchpointContainer',
);
